import {
  getNeutralColors,
  getOrangeColors,
  getBlueColors,
  getlightBlue,
  getVioletColors,
  getGreenColors
} from '@panel/commons/lib/theme';
import moment from 'moment';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';

import locales from '../../locales';
import RadioCheckedNormal from '../../../assets/icons/radio_button_checked.svg';
import RadioCheckedBlue from '../../../assets/icons/radio_button_checked_blue.svg';
import RadioCheckedLigthBlue from '../../../assets/icons/radio_button_checked_VA.svg';
import RadioCheckedDarkGreen from '../../../assets/icons/radio_button_checked_UBPE.svg';

function getStatus(statuses, status) {
  if (statuses) {
    if (statuses.length) {
      return statuses.findIndex(s => s === status) >= 0;
    }
  }
  return false;
}

/**
 * Return true if the messages of lead was read
 * @param {[string]} statuses
 */
export function isRead(statuses) {
  return getStatus(statuses, 'READ');
}

export function isFavorite(statuses) {
  return getStatus(statuses, 'FAVORITE');
}

export function isDiscarded(statuses) {
  return getStatus(statuses, 'DISCARDED');
}

export function isSpam(statuses) {
  return getStatus(statuses, 'SPAM');
}

export function isFinish(statuses) {
  return getStatus(statuses, 'DELETED');
}

export function deleteStatus(statuses, status) {
  const index = statuses.findIndex(st => st === status);
  if (index >= 0) {
    statuses.splice(index, 1);
  }
  return statuses;
}

export function checkArray(array) {
  if (Array.isArray(array) && array.length) {
    return true;
  }
  return false;
}

export function buildFilter(key, values) {
  const splited = values ? values.split(',') : [];
  let filters = '';
  if (splited.length > 0) {
    splited.forEach(value => {
      filters += `&${key}=${value}`;
    });
  }
  return filters;
}

export function getLocale() {
  const siteName = process.env.REACT_APP_BUILD_SITE !== undefined ? process.env.REACT_APP_BUILD_SITE : 'ZPAR';
  return locales.get(siteName);
}

export function verificationQS(search) {
  let verifiedSearch = search;
  if (verifiedSearch) {
    if (verifiedSearch.substr(1, 1) === '&') {
      verifiedSearch = `?${verifiedSearch.substring(2, search.length)}`;
    }
  }
  return verifiedSearch;
}

export function getSite() {
  return process.env.REACT_APP_BUILD_SITE !== undefined ? process.env.REACT_APP_BUILD_SITE : 'ZPAR';
}

export function isCm() {
  return process.env.REACT_APP_BUILD_SITE === 'CMBR';
}

export function getBaseColor() {
  const site = getSite();
  switch (site) {
    case 'CMBR':
      return getBlueColors('blueCmineira');
    case 'VAMX':
      return getlightBlue('lightBlueVanuncios');
    case 'UBPE':
      return getGreenColors('darkPE');
    default:
      return getOrangeColors('base');
  }
}

export function getAlternativeColor() {
  const site = getSite();
  switch (site) {
    case 'CMBR':
      return getBlueColors('blueDark');
    case 'VAMX':
      return getlightBlue('lightBlueVanuncios'); // falta este color
    default:
      return getOrangeColors('orangeDark');
  }
}

export function getAlternativeColorSecondary() {
  const site = getSite();
  switch (site) {
    case 'CMBR':
      return getBlueColors('midLight');
    case 'VAMX':
      return getlightBlue('midLight');
    default:
      return getOrangeColors('midLight');
  }
}

export function getBaseColorHexa() {
  const site = getSite();
  switch (site) {
    case 'CMBR':
      return '#002B52';
    case 'VAMX':
      return '#037CC2';
    case 'UBPE':
      return '#0D624E';
    default:
      return '#FF5500';
  }
}

export function getClosedIcon() {
  const site = getSite();
  switch (site) {
    case 'CMBR':
      return 'closeCm';
    case 'VAMX':
      return 'closeVa';
    case 'UBPE':
      return 'closeUBPE';
    default:
      return 'closeCustom';
  }
}

export function getRadiusColor() {
  const site = getSite();
  switch (site) {
    case 'CMBR':
      return RadioCheckedBlue;
    case 'VAMX':
      return RadioCheckedLigthBlue;
    case 'UBPE':
      return RadioCheckedDarkGreen;
    default:
      return RadioCheckedNormal;
  }
}

export function getBaseColorChat() {
  const site = getSite();
  switch (site) {
    default:
      return getNeutralColors('grisOscuroAccesible');
  }
}

export function getColorStatusLeads(status) {
  const statusNumber = parseInt(status, 10);
  switch (statusNumber) {
    case 1:
      return '#FEF9E4';
    case 2:
      return '#EEF7FE';
    case 3:
      return '#F5F5F5';
    case 4:
      return '#FFEBEE';
    default:
      return '';
  }
}

export function getBaseColorChatDate() {
  const site = getSite();
  switch (site) {
    default:
      return getNeutralColors('grisOscuroAccesible');
  }
}

export function isPhoneHeaderSites() {
  const siteId = process.env.REACT_APP_BUILD_SITE;
  return ['IWBR', 'ICBR', 'WIBR'].includes(siteId);
}

export function determinarCheckbox() {
  const site = getSite();
  switch (site) {
    case 'VAMX':
      return 'checkboxVA';
    case 'CMBR':
      return 'checkboxCM';
    case 'UBPE':
      return 'checkboxUBPE';
    default:
      return 'checkbox';
  }
}

export function isBrSites() {
  const siteId = process.env.REACT_APP_BUILD_SITE;
  const isBr = ['IWBR', 'ICBR', 'CMBR', 'WIBR'].includes(siteId);
  if (isBr) {
    return true;
  }

  return false;
}

export function getUnreadSelectedColor() {
  const site = getSite();
  switch (site) {
    case 'VAMX':
      return ' rgba(3, 124, 194, 0.1);';
    case 'CMBR':
      return 'rgb(0 43 82  / 0.1)';
    case 'UBPE':
      return '#DDE6E4';
    default:
      return 'rgb(255 85 0  / 0.1)';
  }
}

export function determinarCheckboxDefault() {
  const site = getSite();
  switch (site) {
    case 'VAMX':
      return 'checkboxDefaultVA';
    case 'CMBR':
      return 'checkboxDefaultCM';
    case 'UBPE':
      return 'checkboxDefaultUBPE';
    default:
      return 'checkboxDefault';
  }
}

export function determinarIsRead() {
  const site = getSite();
  switch (site) {
    case 'VAMX':
      return 'unreadVA';
    case 'CMBR':
      return 'unreadCM';
    case 'UBPE':
      return 'unreadUBPE';
    default:
      return 'unread';
  }
}

export const determinarRowActiveFill = () => {
  const site = getSite();
  switch (site) {
    case 'VAMX':
      return '#037CC2';
    case 'CMBR':
      return '#002B52';
    case 'UBPE':
      return '#0D624E';
    default:
      return '#FF5500';
  }
};

export const setComma = value => {
  const noWhiteSpace = value.replace(/ /g, '');
  if (noWhiteSpace.length > 0) {
    const isComma = noWhiteSpace.substr(value.length - 1, 1);
    if (isComma.indexOf(',') >= 0) {
      return value;
    }
  }
  return `${value}, `;
};
export const completeLocation = posting => {
  const { location } = posting;
  const name = location ? location.name : '';
  const parent = location && location.parent ? location.parent.name : '';
  return setComma(name) + parent;
};

export const getStatuses = status => {
  switch (status) {
    case 'READ':
      return 'UNREAD';
    case 'UNREAD':
      return 'READ';
    case 'FAVORITE':
      return 'NONFAVORITE';
    case 'NONFAVORITE':
      return 'FAVORITE';
    case 'DISCARDED':
      return 'NONDISCARDED';
    case 'NONDISCARDED':
      return 'DISCARDED';
    default:
      return '';
  }
};

export const getMessage = (numberOfSelecteds, status) => {
  switch (status) {
    case 'FAVORITE':
      return numberOfSelecteds === 1 ? 'common:snackBar.markAs.favorite' : 'common:snackBar.markAs.favorite_plural';
    case 'NONFAVORITE':
      return numberOfSelecteds === 1 ? 'common:snackBar.markAs.noFavorite' : 'common:snackBar.markAs.noFavorite_plural';
    case 'READ':
      return numberOfSelecteds === 1 ? 'common:snackBar.markAs.read' : 'common:snackBar.markAs.read_plural';
    case 'UNREAD':
      return numberOfSelecteds === 1 ? 'common:snackBar.markAs.unRead' : 'common:snackBar.markAs.unRead_plural';
    case 'DISCARDED':
      return numberOfSelecteds === 1 ? 'common:snackBar.markAs.discarded' : 'common:snackBar.markAs.discarded_plural';
    case 'NONDISCARDED':
      return numberOfSelecteds === 1
        ? 'common:snackBar.markAs.noDiscarded'
        : 'common:snackBar.markAs.noDiscarded_plural';
    case 'SPAM':
      return numberOfSelecteds === 1 ? 'common:snackBar.markAs.spam' : 'common:snackBar.markAs.spam_plural';

    default:
      return '';
  }
};

export const getDireccion = (address, location, unspecified) => {
  const direccion = `${address},${location}`;

  if (direccion !== undefined && direccion.length > 0) {
    return direccion;
  }

  return unspecified;
};

export const getExtension = filename => {
  const doc = [
    'msword',
    'docx',
    'dotx',
    'docm',
    'dotm',
    'officedocument',
    'ms-word',
    'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ];
  const img = ['image/png', 'image/png', 'image/svg+xml', 'image/gif', 'image/jpeg', 'image/jpg', 'image/avif'];
  const calc = [
    'sheet',
    'ms-excel',
    'spreadsheetml',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.ms-excel'
  ];
  const pdf = ['pdf', 'application/pdf'];
  const txt = ['text/plain'];

  if (pdf.includes(filename)) {
    return 'pdfType';
  }

  if (doc.includes(filename)) {
    return 'docType';
  }

  if (calc.includes(filename)) {
    return 'xlsType';
  }

  if (txt.includes(filename)) {
    return 'textType';
  }

  if (img.includes(filename)) {
    return 'imgType';
  }

  return '';
};

export function setBaseUrl(path) {
  return process.env.REACT_APP_API_LEADS + path;
}

export const calculateDate = lastLeadDate => {
  const today = moment().startOf('day');
  const yesterday = moment()
    .subtract(1, 'days')
    .startOf('day');
  let fecha;
  const date = moment(lastLeadDate);
  if (date >= today) {
    return today.calendar().split(' ')[0];
  }

  if (date >= yesterday) {
    // eslint-disable-next-line prefer-destructuring
    return yesterday.calendar().split(' ')[0];
  }
  fecha = date.format('ddd D MMM');
  fecha = fecha.replace('.', ',');
  return fecha;
};

export function convertKbToMb(kb) {
  return `${(kb / 1048576).toFixed(2)} MB`;
}

export function attachmentEnabled() {
  const siteId = process.env.REACT_APP_BUILD_SITE;
  return ['ZPAR', 'CAPA', '24MX', 'WIBR', 'IWBR', 'CMBR'].includes(siteId);
}

export function documentEnabled() {
  const siteId = process.env.REACT_APP_BUILD_SITE;
  return ['DVPE', 'UBPE'].includes(siteId);
}

export function feedBackeNotEnabled() {
  const siteId = process.env.REACT_APP_BUILD_SITE;
  return ['VAMX'].includes(siteId);
}

export function formatNumberWithDots(number) {
  if (number === null || number === undefined || number === '') {
    return '';
  }

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export const allowTypes = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'image/avif',
  'image/svg+xml'
];

export const tabEmail = ['1', '2', '3', '14', '12'];

export const tabViewPhone = ['6'];

export const tabViewWhatsapp = ['10'];

export const tabViewOthers = ['11', '15'];

export function getLastDateEmail(leads) {
  let fechaMasRecienteMensaje;
  let enabledMensajes = false;
  leads.forEach(lead => {
    const accionesMensajes = lead.actions.filter(action => tabEmail.includes(action.type.id));
    if (accionesMensajes.length > 0) {
      enabledMensajes = true;
      accionesMensajes.forEach(action => {
        const fechaAction = new Date(action.date);
        // Comprueba si fechaMasRecienteMensaje no está definido o si la fecha actual es posterior a fechaMasRecienteMensaje
        if (!fechaMasRecienteMensaje || fechaAction > fechaMasRecienteMensaje) {
          fechaMasRecienteMensaje = moment(fechaAction); // Actualiza fechaMasRecienteMensaje si la fecha actual es posterior
        }
      });
    }
  });
  return {
    fechaMasRecienteMensaje,
    enabledMensajes
  };
}

export function getLastDatesWh(leads) {
  let fechaMasRecienteWhatsapp;
  let enabledWhatsapp = false;

  leads.forEach(lead => {
    const accionesWhatsapp = lead.actions.filter(action => tabViewWhatsapp.includes(action.type.id));
    if (accionesWhatsapp.length > 0) {
      enabledWhatsapp = true;
      accionesWhatsapp.forEach(action => {
        const fechaAction = new Date(action.date);
        if (!fechaMasRecienteWhatsapp || fechaAction > fechaMasRecienteWhatsapp) {
          fechaMasRecienteWhatsapp = moment(fechaAction);
        }
      });
    }
  });

  return {
    fechaMasRecienteWhatsapp,
    enabledWhatsapp
  };
}

export function getLastDatesPhoneCall(leads) {
  let enabledViewPhone = false;
  let fechaMasRecienteViewPhone;

  leads.forEach(lead => {
    const accionesViewPhone = lead.actions.filter(action => tabViewPhone.includes(action.type.id));
    if (accionesViewPhone.length > 0) {
      enabledViewPhone = true;
      accionesViewPhone.forEach(action => {
        const fechaAction = new Date(action.date);
        if (!fechaMasRecienteViewPhone || fechaAction > fechaMasRecienteViewPhone) {
          fechaMasRecienteViewPhone = moment(fechaAction);
        }
      });
    }
  });

  return {
    fechaMasRecienteViewPhone,
    enabledViewPhone
  };
}

export function getLastDatesOther(leads) {
  let fechaMasRecienteOther;
  let enabledOtherTab;
  leads.forEach(lead => {
    const accionesOther = lead.actions.filter(action => tabViewOthers.includes(action.type.id));
    if (accionesOther.length > 0) {
      enabledOtherTab = true;
      accionesOther.forEach(action => {
        const fechaAction = new Date(action.date);
        if (!accionesOther || fechaAction > fechaMasRecienteOther) {
          fechaMasRecienteOther = moment(fechaAction);
        }
      });
    }
  });

  return {
    enabledOtherTab,
    fechaMasRecienteOther
  };
}

export function GetUtmLink() {
  return '?utm_source=panel&utm_medium=link';
}

export function GetUtmWhatsapp() {
  return '?utm_source=panel&utm_medium=whatsapp';
}

export function GetResponsiveCarrousel() {
  const responsive = {
    desktop: {
      breakpoint: {
        max: 3000,
        min: 1024
      },
      items: 5,
      partialVisibilityGutter: 0,
      slidesToSlide: 1
    },

    tablet: {
      breakpoint: {
        max: 1279,
        min: 768
      },
      items: 3,
      partialVisibilityGutter: 0
    },

    mobile: {
      breakpoint: {
        max: 767,
        min: 320
      },
      items: 2,
      partialVisibilityGutter: 0
    }
  };
  return responsive;
}

export function GetResponsiveCarrouselTab() {
  const responsive = {
    mobile: {
      breakpoint: {
        max: 767,
        min: 320
      },
      items: 1,
      partialVisibilityGutter: 10 // this is needed to tell the amount of px that should be visible.
    }
  };
  return responsive;
}

export function getStatusMarginIcon(id, verticalMarginOff = false) {
  const option = Number(id);

  let margin = '';

  switch (option) {
    case 2:
      margin = verticalMarginOff ? '0px 4px 0px 6px' : '3px 4px 0px 6px';
      break;
    case 3:
      margin = verticalMarginOff ? '-4px 5px 0px 7px' : '0px 5px 5px 7px';
      break;
    default:
      margin = verticalMarginOff ? '-2px 5px 0px 7px' : '1px 5px 5px 7px';
  }

  return margin;
}

export function getEtiquetaIcon(id) {
  const option = Number(id);

  let name = '';

  switch (option) {
    case 2:
      name = 'Contactado';
      break;
    case 3:
      name = 'Finalizado';
      break;
    case 4:
      name = 'Incorrecto';
      break;
    default:
      name = 'Pendiente';
  }

  return name;
}
export function getTransitionsFromState(leadStatus, stateId, status) {
  try {
    const transitions = leadStatus.transitions[stateId];
    if (!transitions) {
      return [];
    }

    // Crea una copia del arreglo de transiciones y agrega el status.id
    const updatedTransitions = [...transitions, status.id];

    // Mapea las transiciones a los objetos esperados
    const mappedTransitions = updatedTransitions.map(transitionId => ({
      id: transitionId,
      name: leadStatus.states[transitionId].charAt(0).toUpperCase() + leadStatus.states[transitionId].slice(1)
    }));

    // Ordenar las transiciones por id
    return mappedTransitions.sort((a, b) => a.id - b.id);
  } catch (e) {
    return [];
  }
}
